import {connect} from "react-redux";
import RejectBAVActivity from "./Reject";
import {bindActionCreators} from "redux";
import {rejectActivity} from "../../../../service/Activity/action";
import {viewActivity} from "../../../../service/Activity/action";

const mapStateToProps = (state) => ({
    rejectActivityDetails:state.Activity.rejectActivity,
    activityByIdDetails:state.Activity.activityByIdDetails,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            rejectActivity,
            viewActivity,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(RejectBAVActivity);
